export function CrmPreloader() {
  return (
    <div className="crm-preloader" role="status" aria-label="Загрузка CRM">
      <svg viewBox="0 0 64 64" fill="currentColor" aria-hidden="true">
        <rect x="10" y="16" width="12" height="32" rx="6" />
        <rect x="26" y="10" width="12" height="44" rx="6" fill="#c56a3d" />
        <rect x="42" y="16" width="12" height="32" rx="6" />
      </svg>
      <span>ROVERO CRM</span>
    </div>
  );
}
